export const noneOption = 'None';

export const options = [
  'Message board',
  'Small group activity',
  'Play time',
  'Large group activity',
  'Story time',
];
